import dayjs from "dayjs";
import { makeAutoObservable } from 'mobx';

export default class SetReminderStore {
    onSetDate: ((date: Date | null) => void) | null = null;

    constructor() {
        makeAutoObservable(this);
    }

    open(onSetDate: (date: Date | null) => void) {
        this.onSetDate = onSetDate;
    }

    setDate(date: Date | null) {
        this.onSetDate!(date);
        this.onSetDate = null;
    }

    setDateWithDateOption(dateOption: DateOption) {
        if (dateOption === DateOption.Custom) {
            this.setDate(null);
            return;
        }

        let date = new Date();
        switch (dateOption) {
            case DateOption.Week1: {
                date.setDate(date.getDate() + 7);
                break;
            }
            case DateOption.Week2: {
                date.setDate(date.getDate() + 14);
                break;
            }
            case DateOption.Month1: {
                date = dayjs(date).add(1, "month").toDate();
                break;
            }
            case DateOption.Day90: {
                date.setDate(date.getDate() + 90);
                break;
            }
            case DateOption.Month6: {
                date = dayjs(date).add(6, "month").toDate();
                break;
            }
            case DateOption.Year1: {
                date = dayjs(date).add(1, "year").toDate();
                break;
            }
            case DateOption.Year2: {
                date = dayjs(date).add(2, "year").toDate();
                break;
            }
        }

        const dayOfWeek = date.getDay();
        if (dayOfWeek === 6)
            date.setDate(date.getDate() + 2);
        if (dayOfWeek === 0)
            date.setDate(date.getDate() + 1);

        this.setDate(date);
    }

    close() {
        this.onSetDate = null;
    }

    isOpen(): boolean {
        return !!this.onSetDate;
    }

    clear() {
        this.onSetDate = null;
    }
}

export enum DateOption {
    Custom = "Custom",
    Week1 = "Week1",
    Week2 = "Week2",
    Month1 = "Month1",
    Day90 = "Day90",
    Month6 = "Month6",
    Year1 = "Year1",
    Year2 = "Year2",
}